import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  item: {
    marginRight: theme.spacing(4),
    marginBottom: theme.spacing(4),
    padding: '0.5rem 2.5rem',
    cursor: 'pointer',
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1',
    '@media only screen and (max-width: 1061px) and (min-width: 500px) ': {
      flex: 0
    },
    '@media (max-width:600px)': {
      flexDirection: 'row',
      justifyContent: 'space-around'
    }
  },
  top: {
    display: 'flex'
  },
  totalCount: {
    marginRight: '1rem'
  }
}));

const ApproveTimesheetStatus = ({ timesheetStatusList, filter, setFilter }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {timesheetStatusList.map((status, index) => {
        if (status.label === 'All') {
          return null;
        }

        return (
          <div
            key={index}
            className={classes.item}
            onClick={() =>
              setFilter({
                ...filter,
                timesheetPeriod: filter.timesheetPeriod,
                startDate: filter.startDate,
                endDate: filter.endDate,
                timesheetStatus: status.label
              })
            }
            style={{ backgroundColor: filter.timesheetStatus == status.label ? '#f2740d' : '#3f51b5' }}
          >
            <div className={classes.top}>
              <p className={classes.totalCount}>{status.totalCount}</p>
              <p>{status.label}</p>
            </div>
            <div>
              <p>{status.totalHours} hrs</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ApproveTimesheetStatus;

ApproveTimesheetStatus.propTypes = {
  timesheetStatusList: PropTypes.array,
  filter: PropTypes.shape({
    timesheetPeriod: PropTypes.string,
    startDate: PropTypes.null || PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    timesheetStatus: PropTypes.string
  }),
  setFilter: PropTypes.func
};
